/**
 * поставить оценку записи блога
 */
eventClick('.blog-rating-add', (el) => {
    const blog_id = el.attr('data-blog-id');
    const rating = 4;
    if (!blog_id) {
        console.error('blog rate error, blog_id is empty');
        return false;
    }
    request(
        'POST',
        route('blog.add-rate', current_region, blog_id),  // guest route
        { 'rating': rating },
        (response) => {
            console.log('blog rated');
            alert('ваш голос учтен!');
        },
        (error, error_code) => {
            console.log('blog rate error', error_code, error);
        }
    )
})

/**
 *  подгрузить следующую страницу записей блогов
 */
eventClick('.blog-more-btn', function (el) {
    const load_more_el = $('.blog-more-btn');
    const next_page = parseInt(load_more_el.attr('data-current-page')) + 1;
    const url = window.location.href;
    const parts = url.split('/');

    const url_last_part = parts[parts.length - 1];

    const queryString = {}

    if (url_last_part !== 'blogs') {
         queryString.page = next_page;
    }
    // проверяем наличие фильтра по тэгам
    if (url_last_part.includes('tag=') && url_last_part.includes('blog')) {
        let match = url.match(/[?&]tag=([^&]*)/);
        let tag_value = match ? match[1] : null;
        if (tag_value)
            queryString.tag = tag_value
    }
    // проверяем наличие фильтра по категориям
    if (url_last_part.includes('category=') && url_last_part.includes('blog')) {
        let match = url.match(/[?&]category=([^&]*)/);
        let category_value = match ? match[1] : null;
        if (category_value)
            queryString.category = category_value
    }

    request('GET', route('blog.load_more', window.current_region), queryString, function (response) {
        load_more_el.attr('data-current-page', next_page);
        $('.blog-grid').append(response)
        // если вернулся пустой ответ, прячем кнопку
        if (response === '')
             load_more_el.hide();
    })
})
